import React from 'react';
import { Box, Tab } from '@mui/material';
import {
  Style as StyleIcon,
  Collections as CollectionsIcon,
} from '@mui/icons-material';
import Tabs from '../UIKit/Tabs';
import { useTranslation } from 'react-i18next';

const BadgeManagementTabs = ({ activeTab, handleTabChange }) => {
  const { t } = useTranslation(['badges']);

  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        borderRadius: { xs: '12px', sm: '16px' },
        p: '4px',
        width: '100%',
        overflow: 'hidden',
        mb: 3,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="badges management tabs"
      >
        <Tab
          label={t('badges:management.tabs.badges')}
          icon={<StyleIcon />}
          iconPosition="start"
        />
        <Tab
          label={t('badges:management.tabs.series')}
          icon={<CollectionsIcon />}
          iconPosition="start"
        />
      </Tabs>
    </Box>
  );
};

export default BadgeManagementTabs;
